import { createGlobalStyle, css } from 'styled-components';
import { theme } from './themes';
import { Rubik } from 'next/font/google';

const rubick = Rubik({
  subsets: ['latin', 'cyrillic', 'cyrillic-ext'],
  display: 'swap',
});

const GlobalStyleComponent = createGlobalStyle`

html {
  font-family: ${rubick.style.fontFamily} !important; 
}

  body {
    background-color: ${theme.colors.background};
    color: ${theme.colors.white};
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
      /* background-image: url('/images/background/parallax-first.svg'),
    url('/images/background/parallax-second.svg');  */
  background-repeat: repeat-y, repeat-y;
  background-size: contain;
  background-position: right -200px,left 200px;
  user-select: none;

   @media (orientation : landscape) {
      //padding-right: 50px;//move to MobileMenuWrapper for reward compatibility
  }
  @media (min-width: 1024px) {
      padding-right: 0px;
  }
  }

  .flex-1 {
    flex:1
  }

  * {
    padding: ${theme.RANGE.NONE};
    margin: ${theme.RANGE.NONE};
    outline: none;
    font-family: ${rubick.style.fontFamily} !important; 
    box-sizing: border-box; 
    text-decoration: none; 
    letter-spacing: -0.015em;
    /* user-select: none; */
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(65, 77, 107, 0.40);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(65, 77, 107, 0.60);
  }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
[data-radix-popper-content-wrapper] {
  z-index: 100 !important;


  @media (max-width: 768px) {
    min-width: 100% !important;
    max-height: calc(100vh - 115px) !important;
    overflow-y: scroll;
  }
}
.my-custom-popover-class {
  background-color: rgba(27, 32, 45, 0.96);
  color:#EDEFF5;
}
.driver-popover-arrow {
 
  content: "";
    position: absolute;
    border: 5px solid rgba(27, 32, 45, 0.96);
}

.driver-popover-arrow-side-left {
    left: 100%;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-top-color: transparent;
}

.--fill {
  padding-right:0px;
}
`;

export default GlobalStyleComponent;
